function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgReportsOutline = function SvgReportsOutline(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 256 \\u2013 205",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "40q1d46eba"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2492",
    style: {
      fill: "none"
    },
    d: "M0 0h15.01v18H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2300",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4665"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4664",
    style: {
      clipPath: "url(#40q1d46eba)"
    },
    transform: "translate(2.5 1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1004",
    d: "M13.412 0a3.757 3.757 0 0 1 .46.153 1.866 1.866 0 0 1 1.136 1.821V16.001a1.923 1.923 0 0 1-.671 1.556 1.786 1.786 0 0 1-1.189.443H1.863a1.859 1.859 0 0 1-1.851-1.754c0-.087-.009-.175-.009-.263Q0 9 0 2.009A1.86 1.86 0 0 1 .807.348 4.738 4.738 0 0 1 1.6 0zm.844 9.018v-7.03A1.136 1.136 0 0 0 13.02.754Q7.5.753 1.983.755A1.581 1.581 0 0 0 1.6.793a1.13 1.13 0 0 0-.845 1.185V16A1.137 1.137 0 0 0 2 17.247h11.02a1.624 1.624 0 0 0 .4-.043 1.121 1.121 0 0 0 .837-1.155v-7.03",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1005",
    d: "M2.254 9.736a3.752 3.752 0 1 1 7.5.1 3.752 3.752 0 0 1-7.5-.1m1.931 2.375a2.969 2.969 0 0 0 3.361.209A2.986 2.986 0 0 0 6.38 6.791v.191c0 .878-.006 1.756 0 2.635a.652.652 0 0 1-.215.509c-.622.612-1.236 1.232-1.853 1.849-.045.044-.087.09-.131.136m-.549-.517c.658-.66 1.292-1.293 1.919-1.933a.337.337 0 0 0 .069-.22c.005-.826 0-1.652 0-2.478 0-.056-.006-.112-.009-.168a2.917 2.917 0 0 0-2.356 1.773 2.974 2.974 0 0 0 .381 3.026",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1006",
    d: "M7.506 15.75H2.691c-.277 0-.443-.152-.433-.391a.356.356 0 0 1 .309-.349A1.446 1.446 0 0 1 2.8 15h9.419a1.333 1.333 0 0 1 .245.015.357.357 0 0 1 .294.379.366.366 0 0 1-.326.355 1.718 1.718 0 0 1-.176 0h-4.75",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1007",
    d: "M11.618 6.749h-.719a.38.38 0 0 1-.4-.358A.372.372 0 0 1 10.87 6q.762-.013 1.525 0a.353.353 0 0 1 .357.391.363.363 0 0 1-.38.353h-.754",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1008",
    d: "M11.631 9h-.736a.38.38 0 0 1-.394-.363.375.375 0 0 1 .375-.383c.5-.008 1-.009 1.507 0a.358.358 0 0 1 .371.38.369.369 0 0 1-.4.366h-.719",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1009",
    d: "M11.624 11.249h-.719a.382.382 0 0 1-.4-.37.376.376 0 0 1 .382-.376q.744-.013 1.489 0a.361.361 0 0 1 .382.388.37.37 0 0 1-.41.36h-.719",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1010",
    d: "M11.629 13.5h-.736a.38.38 0 0 1-.392-.365.368.368 0 0 1 .359-.378q.771-.015 1.542 0a.352.352 0 0 1 .352.379.366.366 0 0 1-.389.364h-.736",
    style: {
      fill: "#1a1818"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportsOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reports_outline.88b560aa.svg";
export { ForwardRef as ReactComponent };